export default "__VITE_ASSET__EzzUa2ca__"